import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

function SeoRow({ p, onSaved }) {
  const [d, setD] = useState(p);
  const save = async () => {
    try { await api.put(`/seo/${p.page_key}`, { title: d.title, description: d.description, keywords: d.keywords || "" }); toast.success(`Saved ${p.path}`); onSaved(); }
    catch { toast.error("Save failed"); }
  };
  return (
    <div className="bg-white border border-[#E2E8F0] rounded-md p-4 space-y-2" data-testid={`seo-row-${p.page_key}`}>
      <div className="flex items-center justify-between"><span className="font-mono text-xs bg-[#F8FAFC] px-2 py-1 rounded">{p.path}</span>
        <span className={`text-xs ${d.title?.length > 60 ? "text-red-500" : "text-slate-400"}`}>{d.title?.length || 0}/60 · {d.description?.length || 0}/160</span></div>
      <div><Label>Title</Label><Input data-testid={`seo-title-${p.page_key}`} value={d.title || ""} onChange={e=>setD({...d, title: e.target.value})}/></div>
      <div><Label>Meta Description</Label><Textarea rows={2} data-testid={`seo-desc-${p.page_key}`} value={d.description || ""} onChange={e=>setD({...d, description: e.target.value})}/></div>
      <div><Label>Keywords</Label><Input value={d.keywords || ""} onChange={e=>setD({...d, keywords: e.target.value})}/></div>
      <Button size="sm" className="btn-orange" onClick={save} data-testid={`seo-save-${p.page_key}`}>Save</Button>
    </div>
  );
}

export default function AdminSeo() {
  const [pages, setPages] = useState([]);
  const load = () => api.get("/seo").then(r => setPages(r.data));
  useEffect(() => { load(); }, []);
  return (
    <div>
      <h1 className="font-heading font-extrabold text-2xl mb-2">SEO Manager</h1>
      <p className="text-sm text-slate-600 mb-6">Edit page titles and meta descriptions. Product titles, descriptions and URL slugs are edited per product in <Link to="/admin/products" className="text-[#EA580C] underline">Products</Link>.</p>
      <div className="grid lg:grid-cols-2 gap-4 max-w-6xl">{pages.map(p => <SeoRow key={p.page_key} p={p} onSaved={load}/>)}</div>
    </div>
  );
}
